import { gql, TypedDocumentNode } from '@apollo/client'

// type IAgency = {
//   agencyId: string
//   agencyKey: string | null
//   agencyName: string
//   agencyGroupId?: number | null
// }

export interface IAgency {
  agencyId: string
  agencyName: string
  agencyKey: string | null
  agencyGroupId?: number
  // agencySubConfigs: IAgencySubConfig[]
}

type GetAgenciesByAgencyGroupIdQuery = {
  getAgenciesByAgencyGroupId: IAgency[]
}

type GetAgenciesByAgencyGroupIdVariable = {
  agencyGroupId: number
  take?: number
  skip?: number
}

export const GET_AGENCIES_BY_AGENCY_GROUP_ID: TypedDocumentNode<
  GetAgenciesByAgencyGroupIdQuery,
  GetAgenciesByAgencyGroupIdVariable
> = gql`
  query GetAgenciesByAgencyGroupId($agencyGroupId: Int!, $take: Int, $skip: Int) {
    getAgenciesByAgencyGroupId(agencyGroupId: $agencyGroupId, take: $take, skip: $skip) {
      agencyId
      agencyKey
      agencyName
    }
  }
`

type SearchAgencyByAgencyNameQuery = {
  searchAgencyByAgencyName: IAgency[]
}

type SearchAgencyByAgencyNameVariable = {
  agencyName: string
  agencyGroupId: number
  skip: number
  take: number
  includingAgencyIds: string[]
  isFetchAll?: boolean
}

export const SEARCH_AGENCIES_BY_AGENCY_NAME: TypedDocumentNode<
  SearchAgencyByAgencyNameQuery,
  SearchAgencyByAgencyNameVariable
> = gql`
  query SearchAgencyByAgencyName(
    $agencyName: String!
    $skip: Int
    $take: Int
    $agencyGroupId: Int!
    $isFetchAll: Boolean
    $includingAgencyIds: [String!]
  ) {
    searchAgencyByAgencyName(
      agencyName: $agencyName
      skip: $skip
      take: $take
      agencyGroupId: $agencyGroupId
      includingAgencyIds: $includingAgencyIds
      isFetchAll: $isFetchAll
    ) {
      agencyId
      agencyKey
      agencyName
    }
  }
`

type AddOrEditAgencyToAgencyGroupVariables = {
  data: {
    agencyGroupId: number
    agencyIds: string[]
  }
}

type AddOrEditAgencyToAgencyGroupMutation = {
  addOrEditAgencyToAgencyGroup: boolean
}

export const ADD_OR_EDIT_AGENCY_TO_AGENCY_GROUP: TypedDocumentNode<
  AddOrEditAgencyToAgencyGroupMutation,
  AddOrEditAgencyToAgencyGroupVariables
> = gql`
  mutation AddOrEditAgencyToAgencyGroup($data: AddOrEditAgencyToAgencyGroupInput!) {
    addOrEditAgencyToAgencyGroup(data: $data)
  }
`

type ImportAgenciesToAgencyGroupMutation = {
  importAgenciesToAgencyGroup: {
    newAgencies: IAgency[]
    existAgencies: IAgency[]
  }
}

export type IAgencyCSV = {
  agencyName: string
  agencyKey: string
}

type ImportAgenciesToAgencyGroupVariable = {
  data: {
    agencies: IAgencyCSV[]
    agencyGroupId: number
  }
}

export const IMPORT_AGENCY_TO_AGENCY_BY_CSV_FILE: TypedDocumentNode<
  ImportAgenciesToAgencyGroupMutation,
  ImportAgenciesToAgencyGroupVariable
> = gql`
  mutation ImportAgenciesToAgencyGroup($data: ImportAgencyToAgencyGroupInput!) {
    importAgenciesToAgencyGroup(data: $data) {
      newAgencies {
        agencyId
        agencyKey
        agencyName
        agencyGroupId
      }
      existAgencies {
        agencyId
        agencyKey
        agencyName
        agencyGroupId
      }
    }
  }
`
